export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3a2 2 0 012 2v10a2 2 0 01-2 2h-4v4a1 1 0 01-1 1H5v-2h3v-3H4a2 2 0 01-2-2V5a2 2 0 012-2h16zM10 20h4v-8.5h-4V20zm-6-5h4v-4.5a1 1 0 011-1h6a1 1 0 011 1V15h4V5H4v10z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};